import { CREATE_DMPLIST_SUCCESS, CREATE_DMP_EMPTYARRAY } from "../../../constant/actionTypes";


let initialState = {
  league_id: "",
  matches: []
}

const createDmpListReducer = (state = initialState, action) => {
  switch (action.type) {
    case CREATE_DMPLIST_SUCCESS: {
      let obj = {
        league_id: action.payload.leagueID,
        matches: [...action.payload.player]
      };
      return obj;
    }
    // case CREATE_DMP_EMPTYARRAY: {
    //   let subArray = []
    //   for (let index = 0; index < 32; index++) {
    //     subArray.push(["", ""])
    //   }
    //   let obj = {
    //     loading: true,
    //     data: subArray,
    //   };
    //   return obj;
    // }
    default:
      return state;
  }
}

export default createDmpListReducer;